export default {
    index: {
        listagem_unidades: 'Listado de Unidades',
        unidade_nao_encontrada: 'No se encontró ninguna unidad',
        criar_unidade: 'Crear Unidad',
        editar: 'Editar',
        nome: 'Nombre',
        apelido: 'Apellido'
    },
    form: {
        unidades: 'Unidades',
        empresa_principal: 'Empresa Principal',
        informacoes: 'Información',
        nome: 'Nombre',
        nome_descricao: 'Nombre de la Unidad',
        mnemonico: 'Mnemotécnico',
        mnemonico_descricao: 'Unidad Mnemotécnica',
        veus_id_descricao: 'ID de la unidad en Veus Saúde',
        vinculo: 'Vínculo',        
        empresa_principal_descricao: 'Empresa Principal',
        unidade_criada_sucesso: '¡Unidad creada con éxito!',
        unidade_atualizada_sucesso: '¡Unidad actualizada con éxito!'
    }
}